export default function LoadingFormUpdateSponsor() {
  return (
    <div className="flex animate-pulse flex-col gap-4">
      {[...Array(8)].map((_, index) => (
        <div
          key={index}
          className="flex flex-col gap-4 md:flex-row"
        >
          <div className="flex w-full flex-col gap-2">
            <div className="h-4 w-32 rounded-md bg-gray-100" />
            <div className="h-10 w-full rounded-md bg-gray-100" />
          </div>

          <div className="flex w-full flex-col gap-2">
            <div className="h-4 w-32 rounded-md bg-gray-100" />
            <div className="h-10 w-full rounded-md bg-gray-100" />
          </div>
        </div>
      ))}

      <div className="flex flex-col gap-2">
        <div className="h-4 w-32 rounded-md bg-gray-100" />
        <div className="h-20 w-full rounded-md bg-gray-100" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="h-4 w-32 rounded-md bg-gray-100" />
        <div className="h-20 w-full rounded-md bg-gray-100" />
      </div>

      <div className="h-12 w-40 self-end rounded-md bg-gray-100" />
    </div>
  )
}
